import React, { useState, useEffect } from 'react';
import ApplicationCard from './ApplicationCard';
import styles from '../../styles/Landlord/LandlordApplications.module.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const LandlordApplication = () => {
  const [activeTab, setActiveTab] = useState('recent');
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/users/landlord/applications`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => setApplications(data.applications))
      .catch(err => console.error("Error fetching applications:", err));
  }, []);

  // ✅ Clearly group applications by unit
  const groupApplicationsByUnit = () => {
    return applications.reduce((acc, app) => {
      if (!acc[app.unit]) acc[app.unit] = [];
      acc[app.unit].push(app);
      return acc;
    }, {});
  };

  return (
    <div className={styles.applicationsContainer}>
      <div className={styles.tabs}>
        <button 
          className={`${styles.tabButton} ${activeTab === 'recent' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('recent')}
        >
          Recent
        </button>
        <button 
          className={`${styles.tabButton} ${activeTab === 'unit' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('unit')}
        >
          By Unit
        </button>
      </div>

      <div className={styles.applicationList}>
        {activeTab === 'recent' && applications.map(app => (
          <ApplicationCard key={app.id} application={app} />
        ))}

        {activeTab === 'unit' && Object.entries(groupApplicationsByUnit()).map(([unit, apps]) => (
          <div key={unit} className={styles.unitGroup}>
            <h2 className={styles.unitHeader}>{unit}</h2>
            {apps.map(app => (
              <ApplicationCard key={app.id} application={app} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandlordApplication;
